/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.1
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { MoneytransferContext, useMoneytransferContext } from './moneytransfer-context'
import type * as Fetcher from './moneytransfer-fetcher'
import { moneytransferFetch } from './moneytransfer-fetcher'
import type * as Responses from './moneytransfer-responses'
import type * as Schemas from './moneytransfer-schemas'

export type TransfersListQueryParams = {
  /**
   * Posizione primo elemento da ritornare per la pagina di risultati corrente
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Numero di righe massimo per la pagina di risultati
   *
   * @format int32
   * @default 20
   * @minimum 1
   * @maximum 50
   */
  pagingLimit?: number
  /**
   * The status list of the transfer request, semicolon separated.
   */
  status?: Schemas.TransferStatusValue[]
  /**
   * The start date of the transfer request, format yyyy-MM-dd.
   *
   * @format date-time
   */
  from?: string
  /**
   * The end date of the transfer request, format yyyy-MM-dd.
   *
   * @format date-time
   */
  to?: string
  /**
   * The sort order of the transfer request, +date (ascending) or -date (descending).
   */
  sort?: '+date' | '-date'
  /**
   * Filters the transfers by membership ID.
   */
  membershipId?: string
}

export type TransfersListHeaders = {
  /**
   * The Membership id of the logged in user
   */
  ['X-Membershipid']?: string
  /**
   * The Tenant id of the logged in user
   */
  ['X-Tenant']?: string
  /**
   * The User id of the logged in user
   */
  ['X-User']?: string
}

export type TransfersListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: Responses.ErrorBadRequest
}>

export type TransfersListVariables = {
  headers?: TransfersListHeaders
  queryParams?: TransfersListQueryParams
} & MoneytransferContext['fetcherOptions']

/**
 * Returns the list of the Money Transfer request
 */
export const fetchTransfersList = (variables: TransfersListVariables, signal?: AbortSignal) =>
  moneytransferFetch<
    Schemas.TransferPaginated,
    TransfersListError,
    undefined,
    TransfersListHeaders,
    TransfersListQueryParams,
    {}
  >({ url: '/transfers', method: 'get', ...variables, signal })

/**
 * Returns the list of the Money Transfer request
 */
export const useTransfersList = <TData = Schemas.TransferPaginated>(
  variables: TransfersListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.TransferPaginated, TransfersListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useMoneytransferContext(options)
  return reactQuery.useQuery<Schemas.TransferPaginated, TransfersListError, TData>({
    queryKey: queryKeyFn({
      path: '/transfers',
      operationId: 'transfersList',
      variables,
    }),
    queryFn: ({ signal }) => fetchTransfersList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type TransferRequestCreateHeaders = {
  /**
   * The Membership id of the logged in user
   */
  ['X-Membershipid']?: string
  /**
   * The Tenant id of the logged in user
   */
  ['X-Tenant']?: string
  /**
   * The User id of the logged in user
   */
  ['X-User']?: string
}

export type TransferRequestCreateError = Fetcher.ErrorWrapper<{
  status: 400
  payload: Responses.ErrorBadRequest
}>

export type TransferRequestCreateVariables = {
  body?: Schemas.TransferRequestWithKind
  headers?: TransferRequestCreateHeaders
} & MoneytransferContext['fetcherOptions']

/**
 * New Money Transfer request
 */
export const fetchTransferRequestCreate = (variables: TransferRequestCreateVariables, signal?: AbortSignal) =>
  moneytransferFetch<
    Schemas.TransferResponse,
    TransferRequestCreateError,
    Schemas.TransferRequestWithKind,
    TransferRequestCreateHeaders,
    {},
    {}
  >({ url: '/transfers', method: 'post', ...variables, signal })

/**
 * New Money Transfer request
 */
export const useTransferRequestCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.TransferResponse, TransferRequestCreateError, TransferRequestCreateVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useMoneytransferContext()
  return reactQuery.useMutation<Schemas.TransferResponse, TransferRequestCreateError, TransferRequestCreateVariables>({
    mutationFn: (variables: TransferRequestCreateVariables) => fetchTransferRequestCreate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type TransferRequestGetPathParams = {
  transferId: string
}

export type TransferRequestGetHeaders = {
  /**
   * The Membership id of the logged in user
   */
  ['X-Membershipid']?: string
  /**
   * The Tenant id of the logged in user
   */
  ['X-Tenant']?: string
  /**
   * The User id of the logged in user
   */
  ['X-User']?: string
}

export type TransferRequestGetError = Fetcher.ErrorWrapper<{
  status: 404
  payload: Responses.ErrorEntityNotFound
}>

export type TransferRequestGetVariables = {
  headers?: TransferRequestGetHeaders
  pathParams: TransferRequestGetPathParams
} & MoneytransferContext['fetcherOptions']

/**
 * Returns the details of the Money Transfer request
 */
export const fetchTransferRequestGet = (variables: TransferRequestGetVariables, signal?: AbortSignal) =>
  moneytransferFetch<
    Schemas.TransferResponseWithUserInfo,
    TransferRequestGetError,
    undefined,
    TransferRequestGetHeaders,
    {},
    TransferRequestGetPathParams
  >({ url: '/transfers/{transferId}', method: 'get', ...variables, signal })

/**
 * Returns the details of the Money Transfer request
 */
export const useTransferRequestGet = <TData = Schemas.TransferResponseWithUserInfo>(
  variables: TransferRequestGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.TransferResponseWithUserInfo, TransferRequestGetError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useMoneytransferContext(options)
  return reactQuery.useQuery<Schemas.TransferResponseWithUserInfo, TransferRequestGetError, TData>({
    queryKey: queryKeyFn({
      path: '/transfers/{transferId}',
      operationId: 'transferRequestGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchTransferRequestGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type TransferConfirmPathParams = {
  transferId: string
}

export type TransferConfirmHeaders = {
  /**
   * The Membership id of the logged in user
   */
  ['X-Membershipid']?: string
  /**
   * The Tenant id of the logged in user
   */
  ['X-Tenant']?: string
  /**
   * The User id of the logged in user
   */
  ['X-User']?: string
}

export type TransferConfirmError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
  | {
      status: 409
      payload: Responses.ErrorEntityConflict
    }
  | {
      status: 422
      payload: Responses.ErrorUnprocessableContent
    }
  | {
      status: 503
      payload: Responses.ErrorUnavailable
    }
>

export type TransferConfirmVariables = {
  body?: Schemas.TransferConfirm
  headers?: TransferConfirmHeaders
  pathParams: TransferConfirmPathParams
} & MoneytransferContext['fetcherOptions']

/**
 * Confirm a transfer request
 */
export const fetchTransferConfirm = (variables: TransferConfirmVariables, signal?: AbortSignal) =>
  moneytransferFetch<
    Schemas.TransferResponse,
    TransferConfirmError,
    Schemas.TransferConfirm,
    TransferConfirmHeaders,
    {},
    TransferConfirmPathParams
  >({
    url: '/transfers/{transferId}/confirm',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Confirm a transfer request
 */
export const useTransferConfirm = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.TransferResponse, TransferConfirmError, TransferConfirmVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useMoneytransferContext()
  return reactQuery.useMutation<Schemas.TransferResponse, TransferConfirmError, TransferConfirmVariables>({
    mutationFn: (variables: TransferConfirmVariables) => fetchTransferConfirm({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type HookTransferStatusError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: Responses.ErrorBadRequest
    }
  | {
      status: 404
      payload: Responses.ErrorEntityNotFound
    }
>

export type HookTransferStatusVariables = {
  body: Schemas.TransferStatusHookRequest
} & MoneytransferContext['fetcherOptions']

/**
 * Handle the update of a Money Transfer status
 */
export const fetchHookTransferStatus = (variables: HookTransferStatusVariables, signal?: AbortSignal) =>
  moneytransferFetch<undefined, HookTransferStatusError, Schemas.TransferStatusHookRequest, {}, {}, {}>({
    url: '/hook/transfer/status',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * Handle the update of a Money Transfer status
 */
export const useHookTransferStatus = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, HookTransferStatusError, HookTransferStatusVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useMoneytransferContext()
  return reactQuery.useMutation<undefined, HookTransferStatusError, HookTransferStatusVariables>({
    mutationFn: (variables: HookTransferStatusVariables) => fetchHookTransferStatus({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type QueryOperation =
  | {
      path: '/transfers'
      operationId: 'transfersList'
      variables: TransfersListVariables
    }
  | {
      path: '/transfers/{transferId}'
      operationId: 'transferRequestGet'
      variables: TransferRequestGetVariables
    }
